import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import CommentOutlinedIcon from "@material-ui/icons/CommentOutlined";

class SpecialRemarks extends Component {
  render() {
    const { customTexts, language ,isB2B} = this.props;
    let label = language === "english" ? (isB2B ? customTexts.special_remarks_b2b : customTexts.special_remarks) : (isB2B ? customTexts.special_remarks_b2b_ar : customTexts.special_remarks_ar)
    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {label}
        </p>
        <div
          className="bordered"
          style={{
            backgroundColor: "white",
            minHeight: 80,
            display: "grid",
            gridTemplateColumns: "50px auto 50px",
            alignItems: "center",
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          <div>
            <CommentOutlinedIcon
              style={{
                color: "#5b5b5b",
              }}
            />
          </div>
          <div>
            <TextField
              fullWidth
              onChange={(e) => this.props.setSpecialRemarks(e)}
              color="red"
              style={{
                width: "100%",
                position: "relative",
                top: -10,
                left: 0,
              }}
              defaultValue={this.props.specialRemarks}
              InputLabelProps={{
                style: {
                  transformOrigin:
                    language == "english" ? "top left" : "top right",
                  right: language == "arabic" ? 0 : "unset",
                  left: language == "english" ? 0 : "unset",
                },
                dir: language == "english" ? "ltr" : "rtl",
              }}
              InputProps={{
                dir: language == "english" ? "ltr" : "rtl",
                paddingBottom: 10,
              }}
              label={
                language === "arabic" ? `ادخل ${label}` : `Enter your ${label}`
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customTexts: state.store.store.settings.custom_texts,
  };
};

export default connect(mapStateToProps)(SpecialRemarks);
